@use "Styles/mixins";

:host {
    display: block;
    width: 100%;
}

.form {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    background-color: mixins.get-color(bg, solid, primary);
    border: 1px solid mixins.get-color(border, border-primary);
    box-shadow:
        0px 12px 16px -4px rgba(10, 13, 18, 0.08),
        0px 4px 6px -2px rgba(10, 13, 18, 0.03);
}

:host([compact]) .form {
    flex-direction: row;
    align-items: center;
}

.textarea-wrapper {
    position: relative;
    padding: 12px 16px 4px;

    :host([compact]) & {
        flex: 1 1 0%;
        min-width: 0;
        padding: 10px 0 10px 16px;
    }
}

.typewriter {
    position: absolute;
    top: 12px;
    left: 22px;
    right: 16px;
    height: 24px;
    pointer-events: none;
    font-size: 16px;
    line-height: 24px;
    color: mixins.get-color(text, text-placeholder);
    font-family: inherit;
    white-space: nowrap;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 8px;
}

.typewriter__text--fading {
    opacity: 0;
    transition: opacity 430ms ease;
}

.typewriter__icon {
    flex-shrink: 0;
    color: #75b2ba; // brand-400 — not exposed in $colors
}

.textarea {
    position: relative;
    width: 100%;
    resize: none;
    background-color: transparent;
    color: mixins.get-color(text, text-primary);
    font-family: inherit;
    font-size: 16px;
    line-height: 24px;
    outline: none;
    border: none;
    min-height: 48px;
    max-height: 150px;

    :host([compact]) & {
        min-height: 24px;
    }
}

.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 12px 12px;

    :host([compact]) & {
        padding: 0 8px 0 0;
    }
}

.toolbar__left {
    display: flex;
    align-items: center;
    gap: 4px;

    :host([compact]) & {
        display: none;
    }
}

.toolbar__right {
    display: flex;
    align-items: center;
    gap: 6px;
}

.send-btn {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 150ms;
    cursor: pointer;
    color: mixins.get-color(bg, solid, primary);
    background-color: mixins.get-color(accent, primary);
    border: none;
    padding: 0;

    &:disabled {
        cursor: unset;
        opacity: 0.4;
    }
}

.disclaimer {
    text-align: center;
    font-size: 12px;
    color: mixins.get-color(text, text-tertiary);
    margin: 6px 0 0;
    text-wrap: pretty;
}
